import BoundariesGridRowWrapper from '../BoundariesGridRowWrapper';
import { formatToUSDateTimeWith12Hour } from 'utils/dateTimeUtils/dateFormatUtil';

import GridText from 'components/text/GridText';
import TableLink from 'components/text/TableLink';

import usePageRoutes from 'hooks/usePageRoutes';

import { TEST_ID } from './constants';
import type { FunctionComponent, Props } from './types';

import styles from './styles.module.scss';

const BoundariesGridRow: FunctionComponent<Props> = ({
    id,
    lastActivity,
    lastEdited,
    name,
    ref,
    style,
    testId = TEST_ID
}) => {
    const { boundaryDetailsPage } = usePageRoutes();

    return (
        <BoundariesGridRowWrapper ref={ref} style={style} testId={testId}>
            <TableLink className={styles.tableLink} text={name} to={boundaryDetailsPage(id)} />

            <GridText text={formatToUSDateTimeWith12Hour(lastEdited) ?? '-'} />

            <GridText text={lastActivity ?? '-'} />
        </BoundariesGridRowWrapper>
    );
};

export default BoundariesGridRow;
